const ding = require('../assets/sounds/ding.mp3');

export class AudioService {
  private static foodItemOverTimeSound = new Audio(ding);

  static async playSound(): Promise<void> {
    await this.foodItemOverTimeSound.play();
  }
}